import React from 'react'
import { ICsfHero as IContentfulCSFHero } from 'marketing-site/@types/generated/contentful'

import { CSFHero, IProps as ICSFHero } from 'marketing-site/src/components/bespoke/csf-hero'
import { transformFeatureList } from 'marketing-site/src/transformers/elements/ContentfulFeatureListSimple'
import { transformImage } from 'marketing-site/src/transformers/elements/ContentfulImage'
import { transformJumpLink } from 'marketing-site/src/transformers/elements/ContentfulJumpLink'

export function ContentfulCSFHero(hero: IContentfulCSFHero) {
  return <CSFHero {...transformCSFHero(hero)} />
}

function transformCSFHero({ fields }: IContentfulCSFHero): ICSFHero {
  return {
    ...fields,
    legend: fields.legend && transformFeatureList(fields.legend),
    image: transformImage(fields.image),
    video: fields.video && fields.video.fields.file.url,
    videoWebm: fields.videoWebm && fields.video?.fields.file.url,
    jumpLink: fields.jumpLink && transformJumpLink(fields.jumpLink),
  }
}
